"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PLUGIN_CLASS = exports.CORE_CLASS = exports.CLASS_SYMBOL = void 0;
// const
// @author Pluto <huarse@gmail.com>
// @create 2019/12/30 21:05

/** Class static symbol property name */
const CLASS_SYMBOL = Symbol('CLASS_SYMBOL');
/** Core Class Symbol */

exports.CLASS_SYMBOL = CLASS_SYMBOL;
const CORE_CLASS = Symbol('CORE_CLASS');
/** Plugin Class Symbol */

exports.CORE_CLASS = CORE_CLASS;
const PLUGIN_CLASS = Symbol('PLUGIN_CLASS');
exports.PLUGIN_CLASS = PLUGIN_CLASS;